import { QueryFunctionContext } from '@tanstack/react-query';

import {
  ListStudentAssessments,
  listStudentAssessments,
} from '@/data/services/studentAssessmentsServices';

export const studentAssessmentQueries = {
  all: ['studentAssessments'] as const,

  list: (filters: ListStudentAssessments = {}) => ({
    queryKey: [...studentAssessmentQueries.all, 'list', { filters }] as const,
    queryFn: () => listStudentAssessments(filters),
  }),

  infinite: (filters: ListStudentAssessments = {}) => ({
    queryKey: [
      ...studentAssessmentQueries.all,
      'infinite',
      { filters },
    ] as const,
    queryFn: ({ pageParam }: QueryFunctionContext) =>
      listStudentAssessments({ ...filters, pageNumber: pageParam }),
  }),
};
